import { SignUpProfile, UserProfile } from '../../domain/models/user.model';
import { Action } from '../action.type';

export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_FAILURE = 'GET_USER_PROFILE_FAILURE';
export const CREATE_USER_PROFILE = 'CREATE_USER_PROFILE';
export const CREATE_USER_PROFILE_SUCCESS = 'CREATE_USER_PROFILE_SUCCESS';
export const CREATE_USER_PROFILE_FAILURE = 'CREATE_USER_PROFILE_FAILURE';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAILURE = 'UPDATE_USER_PROFILE_FAILURE';
export const SET_USER_ERROR = 'SET_USER_ERROR';
export const DELETE_USER_PROFILE = 'DELETE_USER_PROFILE';
export const DELETE_USER_PROFILE_SUCCESS = 'DELETE_USER_PROFILE_SUCCESS';
export const DELETE_USER_PROFILE_FAILURE = 'DELETE_USER_PROFILE_FAILURE';

export type GetUserProfilePayload = {
  token: string;
  retry: number;
};

export type CreateUserProfilePayload = {
  token: string;
  profile: SignUpProfile;
  retry: number;
};

export type UserProfileChanges = Partial<UserProfile>;

export type UpdateUserProfilePayload = {
  token: string;
  currentProfile: UserProfile;
  newData: UserProfileChanges;
  retry: number;
};

export type DeleteUserProfilePayload = {
  token: string;
  retry: number;
};

export interface GetUserProfile extends Action<GetUserProfilePayload> {
  type: typeof GET_USER_PROFILE;
  payload: GetUserProfilePayload;
}

export interface GetUserProfileSuccess extends Action<UserProfile> {
  type: typeof GET_USER_PROFILE_SUCCESS;
  payload: UserProfile;
}

export interface GetUserProfileFailure extends Action<string> {
  type: typeof GET_USER_PROFILE_FAILURE;
  payload: string;
}

export interface CreateUserProfile extends Action<CreateUserProfilePayload> {
  type: typeof CREATE_USER_PROFILE;
  payload: CreateUserProfilePayload;
}

export interface CreateUserProfileSuccess extends Action<UserProfile> {
  type: typeof CREATE_USER_PROFILE_SUCCESS;
  payload: UserProfile;
}

export interface CreateUserProfileFailure extends Action<string> {
  type: typeof CREATE_USER_PROFILE_FAILURE;
  payload: string;
}

export interface UpdateUserProfile extends Action<UpdateUserProfilePayload> {
  type: typeof UPDATE_USER_PROFILE;
  payload: UpdateUserProfilePayload;
}

export interface UpdateUserProfileSuccess extends Action<UserProfile> {
  type: typeof UPDATE_USER_PROFILE_SUCCESS;
  payload: UserProfile;
}

export interface UpdateUserProfileFailure extends Action<string> {
  type: typeof UPDATE_USER_PROFILE_FAILURE;
  payload: string;
}

export interface SetUserError extends Action<string> {
  type: typeof SET_USER_ERROR;
  payload: string;
}

export interface DeleteUserProfile extends Action<DeleteUserProfilePayload> {
  type: typeof DELETE_USER_PROFILE;
  payload: DeleteUserProfilePayload;
}

export interface DeleteUserProfileSuccess extends Action<void> {
  type: typeof DELETE_USER_PROFILE_SUCCESS;
}

export interface DeleteUserProfileFailure extends Action<string> {
  type: typeof DELETE_USER_PROFILE_FAILURE;
  payload: string;
}
